import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

const footerNav = {
  Products: [
    { label: 'BriefingIQ', to: '/briefingiq' },
    { label: 'EventIQ', to: '/eventiq' },
    { label: 'Platform', to: '/platform' },
    { label: 'Pricing', to: '/pricing' },
  ],
  Company: [
    { label: 'About', to: '/company' },
    { label: 'Blog', to: '/blog' },
    { label: 'Contact', to: '/contact' },
    { label: 'Careers', to: '/company#careers' },
  ],
  Resources: [
    { label: 'Documentation', to: '/platform' },
    { label: 'Case Studies', to: '/blog' },
    { label: 'Support', to: '/contact' },
    { label: 'Status', to: '/platform' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '/contact' },
    { label: 'Terms of Service', to: '/contact' },
    { label: 'Security', to: '/platform' },
    { label: 'Cookie Policy', to: '/contact' },
  ],
};

const Footer = () => {
  return (
    <footer className="bg-[#0F172A] dark pt-16 pb-28 border-t border-[#1E293B]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-[11px] text-ink-3 leading-relaxed mb-10 max-w-3xl">
          BriefingIQ and EventIQ are enterprise platforms for executive briefing management and corporate event operations. This site is a corporate showcase; all product data shown is illustrative.
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {Object.entries(footerNav).map(([section, links]) => (
            <div key={section}>
              <h4 className="text-[13px] font-semibold text-ink mb-4">{section}</h4>
              <ul className="space-y-2.5">
                {links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-[12px] text-ink-2 hover:text-ink hover:underline transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-[var(--line-2)] pt-8 flex flex-col md:flex-row justify-between gap-4 text-[11px] text-ink-3">
          <div>Copyright © {new Date().getFullYear()} BriefingIQ, Inc. All rights reserved.</div>
          <div className="flex items-center gap-5 flex-wrap">
            <Link to="/contact" className="hover:text-ink transition-colors">Privacy</Link>
            <Link to="/contact" className="hover:text-ink transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-ink transition-colors">Legal</Link>
            <span className="text-[var(--line)]" aria-hidden="true">·</span>
            <Link
              to="/admin/login"
              className="hover:text-ink transition-colors inline-flex items-center gap-1 opacity-70 hover:opacity-100"
              aria-label="Team login"
            >
              <Lock className="w-3 h-3" />
              Team login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
